export const version = "abi/5.6.2";
